<div class="edit-templates-container">
  <mat-card>
    <mat-card-header fxLayout="row" fxLayoutAlign="start start">
      <mat-card-title role="heading" aria-level="1">Select Type of Document</mat-card-title>
    </mat-card-header>
    <mat-card-content fxLayout="row" fxLayoutAlign="start start" class="no-bottom-pad">
      <div class="template-select-card" fxFlex>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Document Type</mat-label>
          <mat-select placeholder="Please Select Type of Document" panelClass="epds-select-override"
                      [(value)]="selectedDocType"
                      (selectionChange)="onDocTypeChange($event)">
            <mat-optgroup *ngFor="let group of docGroups" [label]="group">
              <mat-option *ngFor="let doc of documentsByGroup.get(group)" [value]="doc">
                {{doc.doc_Type_Desc}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>
  <div fxFill *ngIf="isEditorVisible">
    <mat-card fxFill>
    <mat-card-content fxLayout="row" fxLayoutAlign="start" class="no-top-pad">
      <div class="template-editor">
        <ckeditor *ngIf="editorContent" #editor [editor]="ClassicEditor" [config]="CKEditorConfig" [data]="editorContent"></ckeditor>
      </div>
    </mat-card-content>
    <mat-card-actions fxLayout="row" fxLayoutAlign="start" fxLayoutGap="16px">
      <div class="editor-controls">
<!--        <button mat-raised-button color="accent" (click)="onPrintPreview()">Preview</button>-->
        <button mat-raised-button color="primary" (click)="onEditorSave()">
          Save
        </button>
        <button mat-raised-button color="warn" (click)="onEditorCancel()">
          Cancel
        </button>

      </div>

    </mat-card-actions>
    </mat-card>
  </div>

  <div *ngIf="isReviewVisible && docFileName">
    <mat-card>
    <mat-card-content *ngIf="isReviewVisible && docFileName" fxLayout="row" fxLayoutAlign="start" >
      <div class="review-card-body">
        <a href="javascript:void(0)" (click)="onViewDocument()">{{docFileName}}</a>
      </div>
    </mat-card-content>

    <mat-card-actions fxLayout="row" fxLayoutAlign="start" fxLayoutGap="16px">

      <div class="editor-controls">

        <button mat-raised-button color="accent" (click)="onEditTemplate()">
          Edit Template
        </button>
        <button mat-raised-button color="primary" (click)="onSaveEdits()">
          Save Edits
        </button>
        <button mat-raised-button color="warn" (click)="onClearEdits()">
          Clear Edits
        </button>

      </div>

    </mat-card-actions>
    </mat-card>
   </div>


  <iframe #printDataContainer id='print-data-container' aria-hidden="true" tabindex="-1"></iframe>
</div>
